import { CommunityProfileAdminsEnum } from '../../enums';
import { UserDto } from '../../models/dto';

export type CheckPermissionProps = {
	user: UserDto;
	communityProfiles: UserDto[];
	selectedCommunity: UserDto;
};

export function getCommunityProfile(communityProfiles?: UserDto[], userId?: string, communityId?: string) {
	return (communityProfiles ?? []).find(
		(profile) =>
			userId === profile.adminToCommunityProfile?.adminId && communityId === profile.adminToCommunityProfile?.profileId
	);
}

export type CalculatedCommunityRoles = {
	isOriginalOwner?: boolean;
	isOwner?: boolean;
	isLeader?: boolean;
	isVolunteer?: boolean;
};

export function calcCommunityProfileRoles(communityProfileUser?: UserDto): CalculatedCommunityRoles {
	const communityProfile = communityProfileUser?.adminToCommunityProfile;

	const isOriginalOwner = !!communityProfile?.isOriginalOwner;
	const isOwner = communityProfile?.roleId === CommunityProfileAdminsEnum.Admin;
	const isLeader = communityProfile?.roleId === CommunityProfileAdminsEnum.Leader;
	const isVolunteer = communityProfile?.roleId === CommunityProfileAdminsEnum.Volunteer;

	return { isOriginalOwner, isOwner, isLeader, isVolunteer };
}

export const getCommunityProfileAndCalcRoles = (
	communityProfiles?: UserDto[],
	userId?: string,
	communityId?: string
): CalculatedCommunityRoles => {
	const profile = getCommunityProfile(communityProfiles, userId, communityId);
	const roles = calcCommunityProfileRoles(profile);

	return roles;
};
